import React, { useContext } from 'react';
import { Image, ProgressBar } from 'react-bootstrap';
import Skeleton from 'react-loading-skeleton';
import WorkedHours from '../WorkedHours';
import { activityContext } from '../../../pages/Dashboard';
import { useNavigate } from 'react-router-dom';
interface Props {
    title: string,
    isLoading: boolean,
    navigate: (e: React.MouseEvent<Element, MouseEvent>, type: string) => void,
    contributorsList: WorkedHours[]
}

const ContributorsCard: React.FC<Props> = (props) => {
    const { title, isLoading, navigate, contributorsList } = props
    const routerNavigate = useNavigate();
    const isTablet: boolean = useContext(activityContext)?.isTablet as boolean;

    return (
        <>
            <div className="d-flex justify-content-between align-items-center common-card-title title-ctr">
                <h5>{title === 'most' ? 'Top contributors (by hours)' : 'Least contributors (by hours)'}</h5>
                <div className="report-link" onClick={(e) => navigate(e, "hours_tracked_report")}>View full report</div>
            </div>
            <div className="d-flex flex-column user-prs-cont">
                {isLoading ? !isTablet ?
                    Array.from({ length: 5 })?.map((res, i) => (
                        <div className="user-prs-card" key={i}>
                            <div className="d-flex align-items-center w-100">
                                <div className="img-ctr">
                                    <Skeleton count={1} circle={true} className="skel-chart" />
                                </div>
                                <p className="emp-name w-50"><Skeleton className="w-100" count={1} /></p>
                                <p className="wk-hrs w-25"><Skeleton className="w-100" count={1} /></p>
                            </div>
                            <div className="pg-bar-ctr">
                                <Skeleton count={1} className="w-100" />
                            </div>
                        </div>
                    )) :
                    Array.from({ length: 5 })?.map((res, i) => (
                        <div className="user-prs-card" key={i}>
                            <div className="img-ctr">
                                <Skeleton count={1} circle={true} className="skel-chart" />
                            </div>
                            <div className="emp-name">
                                <p ><Skeleton className="w-100" count={1} /></p>
                                <p><Skeleton className="w-100" count={1} /></p>
                            </div>
                            <div className="pg-bar-ctr">
                                <Skeleton count={1} className="w-100 skel-bar" />
                            </div>
                            <p className="wk-hrs"><Skeleton className="w-100" count={1} /></p>
                        </div>
                    )) :
                    contributorsList?.length ? !isTablet ? contributorsList?.map((res, ind) => (
                        <div className="user-prs-card" key={ind}>
                            <div className="d-flex align-items-center">
                                <div className="img-ctr">
                                    {res?.user_info?.image ?
                                        <Image
                                            src={res?.user_info?.image}
                                            alt={res?.user_info?.employee_name}
                                        /> :
                                        <div className="img-avatar">
                                            <p>{res?.user_info?.employee_name?.charAt(0)}</p>
                                        </div>
                                    }
                                </div>
                                {/* <p className="emp-name">{res?.user_info?.employee_name} - <span>{res?.user_info?.employee_code}</span></p> */}
                                <p
                                    className="emp-name"
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => routerNavigate('/employeeOverview', { state: { empCode: res?.user_info?.employee_code } })}
                                    >
                                    {res?.user_info?.employee_name} - <span>{res?.user_info?.employee_code}</span>
                                    </p>
                                <p className="wk-hrs">{res?.total_time}</p>
                            </div>
                            <div className="pg-bar-ctr">
                                <ProgressBar now={res?.total_time_percentage} striped variant={`${title === 'most' ? 'most-grn' : 'least-red'}`} />
                            </div>
                        </div>
                    )) :
                        contributorsList?.map((res, ind) => (
                            <div className="user-prs-card" key={ind}>
                                <div className="img-ctr">
                                    {res?.user_info?.image ?
                                        <Image
                                            src={res?.user_info?.image}
                                            alt={res?.user_info?.employee_name}
                                        /> :
                                        <div className="img-avatar">
                                            <p>{res?.user_info?.employee_name?.charAt(0)}</p>
                                        </div>
                                    }
                                </div>
                                <div className="emp-name">
                                    {/* <p >{res?.user_info?.employee_name}</p> */}
                                    <p
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => routerNavigate('/employeeOverview', { state: { empCode: res?.user_info?.employee_code } })}
                                        >
                                        {res?.user_info?.employee_name}
                                        </p>
                                    <p>{res?.user_info?.employee_code}</p>
                                </div>
                                <div className="pg-bar-ctr">
                                    <ProgressBar now={res?.total_time_percentage} striped variant={`${title === 'most' ? 'most-grn' : 'least-red'}`} />
                                </div>
                                <p className="wk-hrs">{res?.total_time}</p>
                            </div>
                        )) :
                        <div className="d-flex flex-row  w-100 no-data-row">
                            <div className="no-data-image-wrapper no-user-image">
                                <Image src="/images/dashboard/user_icon.png" alt="No Data Found" />
                            </div>
                            <p>No users to show</p>
                        </div>
                }
            </div>
        </>
    );
};

export default ContributorsCard;